@if(!details.succeeded) {
  <div class="padding-inside">No Details Found</div>
}
@else {
  
  <div class="details-container">
    <div class="padding-inside border-bottom">DETAILS:</div>
    @for(item of details.items; track item.label) {
      <div class="border-bottom padding-inside line">
        <span class="subtitle">{{item.label}}:</span> {{item.value}}
      </div>
    }
  </div>

}